<template>
   <div class=" fw">
            <div class="st sec-attraction-foot pd">
                <div class="bg-foot-attraction"></div>
                <div class="container container-1360 mb-5">
                    <div class="position-relative">
                        <div class="ele ele-left-cloud-new"><img src="@/assets/img/element/cloud-1.png" alt=""></div>
                        <div class="ele ele-right-cloud-new"><img src="@/assets/img/element/cloud-1.png" alt=""></div>
                        <div class="st attractiondtl-foot-sec pd">
                            <div class="container container-1360">
                                <div class="position-relative">
                                    <div class="fw ">
                                        <div class="box-title text-center mb-4">
                                            <h2 class="text-uppercase" ><span><b>25 แหล่งท่องเที่ยว Unseen อื่นๆ</b></span> </h2>
                                        </div>
                                        <div class="location-swiper fw">
                                            <div class="box-location-slide">
                                                <div class="swiper location_slide">
                                                    <div class="swiper-wrapper">
                                                        <div class="swiper-slide" v-for="item in location" :key="item">
                                                            <div class="location-slide-con">
                                                                <a :href="item.province_en">
                                                                <div class="card card-vote">
                                                                    <div class="card-img">
                                                                        <img :src="require(`@/assets/img/_77-attractions/${item.image_cover}`)" alt="" class="fw">
                                                                    </div>
                                                                    <div class="card-body px-0 pb-0">
                                                                        <div class="card-cont" >
                                                                            <h6 ref="cardContentLocation"><b v-html="item.location_name"></b></h6>
                                                                            <p class="gray-dark"><small>จ.{{item.province_th}} {{ item.region_th }}</small></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

// SWIPER
import Swiper, { Autoplay, Navigation, Pagination, Controller, EffectFade, } from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);
import "swiper/swiper-bundle.css";
import 'swiper/css/pagination';

import axios from "axios";


export default {
    name: 'unseenComponent',
    data(){
        return{
            location: [],
        }
    },
    mounted(){
        this.getLocation()
    },

    methods:{
        async getLocation(){
            this.isloade = true;
            try {
                const response = await axios.get(
                    `https://www.unseennewchapters.com/nx/API/get_locations_25`
                );
                if (response.data.rs == true) {
                    this.location = response.data.data;
                    this.locationSlide()
                    // console.log(this.location);
                }
            } catch (error) {
                console.log(error);
            }
        },
        locationSlide() {
            this.locationSlideInit = new Swiper('.box-location-slide .location_slide', {
                spaceBetween: 12,
                slidesPerView: 2,
                pagination: {
                    el: '.box-location-slide .swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                speed: 2000,
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    1119: {
                        spaceBetween: 13,
                        slidesPerView: 4,
                        simulateTouch: true,
                    },
                    1359: {
                        spaceBetween: 13,
                        slidesPerView: 4.9,
                    },
                    767: {
                        spaceBetween: 13,
                        slidesPerView: 3,
                    },
                },
            });
        },
        stopAutoplayLocation() {
            this.locationSlideInit.autoplay.stop();
        },
        startAutoplayLocation() {
            this.locationSlideInit.autoplay.start();
        },
    }
    


}
</script>

<style scoped>
.location-slide-con .card-body{
    height: 80px;
}


@media (max-width: 992.98px){
    .card-vote{padding: 10px 10px 30px;}
}
@media (max-width: 767.98px){
    .card-vote{padding: 8px 8px 45px;}
}

@media (max-width: 575.98px){
    .card-vote{padding: 8px 8px 25px;}
}

@media (max-width: 413.98px){
    .card-vote{padding: 8px 8px 45px;}
}

</style>